export default __webpack_public_path__ + "static/media/aa-camera.5ed6f487.svg";